"use client";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import { MobileTopDownMenu } from "./MobileTopDownMenu";

import { useEffect, useMemo, useState } from "react";

import "./styles.scss";

export default function Header() {
  const [isAtTop, setIsAtTop] = useState(true);
  const [showPageMenu, setShowPageMenu] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsAtTop(window.scrollY === 0);
      const handleScroll = () => {
        setIsAtTop(window.scrollY === 0);
      };

      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const homeClass = useMemo(() => {
    return classNames({
      header: true,
      "header-background": !isAtTop,
      "header-menu-background": showPageMenu,
    });
  }, [isAtTop, showPageMenu]);

  return (
    <div className={"fellou-mb-header-display"}>
      <header className={homeClass}>
        <Link href="/">
          <div className={"fellou-logo relative"}>
            <Image
              src="/logo.svg"
              alt="fellou"
              fill
              priority
              unoptimized
            />
          </div>
        </Link>
        <div className={"header-menu"} onClick={() => setShowPageMenu(!showPageMenu)}>
          <div className={"header-menu-box"}>
            {showPageMenu ? (
              <i className="icon iconfont icon-close-menu"></i>
            ) : (
              <i className="icon iconfont icon-menu-line"></i>
            )}
          </div>
        </div>
      </header>
      <MobileTopDownMenu visible={showPageMenu} onClose={() => setShowPageMenu(false)}></MobileTopDownMenu>
    </div>
  );
}
